/**
 * Ulgebra LookUp types and constants.
 * LookUp is a CRM search/lookup tool (not a messaging provider).
 * It uses SaaS auth to search CRM records - no TPA-specific authentication needed.
 */

export const CLIENT_IDS: Record<string, string> = {
  lookupforhubspotcrm: '870ca14e-3b45-4332-9636-32168ff05b12',
  lookupforbitrix24: 'app.63030c3eef5559.49583025',
  lookupforpipedrive: '03e34563487a2340',
};

/**
 * Set of SaaS codes that support the CRM lookup panel.
 * Includes CRMs with dedicated lookup client IDs AND those that use
 * existing SaaS auth for lookup (e.g. Zoho CRM).
 */
export const LOOKUP_SUPPORTED_SAAS = new Set([
  ...Object.keys(CLIENT_IDS).map((key) => key.replace('lookupfor', '')),
  'zohocrm',
  'zohodesk',
  'zohobooks',
  'zohobigin',
  'zohorecruit',
  'salesforce',
  'freshdesk',
  'freshworkscrm',
  'zendesksell',
  'zendesksupport',
  'dynamics',
  'monday',
  'airtable',
  'shopify',
  'activecampaign',
  'high',
]);

/**
 * SaaS codes whose in-conversation lookup panel is rendered as an iframe of
 * the standalone LookUp app (`LookupPanelIframe`) instead of the inline
 * `LookupPanel`. LookUp authorizes these CRMs under its own OAuth client
 * (see `CLIENT_IDS`), so it has to run under its own `appCode` to get a
 * token separate from the messaging app's — matching the legacy app.
 */
export const LOOKUP_IFRAME_SAAS = new Set(['hubspotcrm']);
